<script>
import Layout from "../../layouts/main.vue";
import appConfig from "../../../app.config";
import "@vueform/multiselect/themes/default.css";
import Lottie from "@/components/widgets/lottie.vue";
import animationData from "@/components/widgets/loading-lottie.json";
import dataReady from "@/components/widgets/checkmark-ready.json";
import axios from 'axios';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Omni Channel",
        meta: [{ name: "description", content: appConfig.description }],
    },
    data() {
        return {
            isConected: false,
            qrCodeWa: null,
            waSatus: null,
            defaultOptions: { animationData: animationData },
            optReadyData: {animationData: dataReady},
            whatsappAccount: {},
            showRefreshQr: false,
            statusPolling: null,
            qrPolling: null,
            pollInterval: 10000,
            qrPollInterval: 8000,
            isInitializing: false,
            loadingMessage: 'Please wait...',
            statusInFlight: false,
            qrInFlight: false,
            connectedConfirmCount: 0, // Debounce: harus 2x CONNECTED berturut-turut
        };
    },
    components: {
        Layout,
        lottie: Lottie,
    },
    computed: {
        kodemb() {
            try {
                return JSON.parse(localStorage.getItem("user"))?.Company?.CompanyCode || 'default';
            } catch (e) {
                return 'default';
            }
        }
    },
    methods: {
        async unlinkWa(){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, logout it!",
            }).then(async (result) => {
                if (result.value) {
                    this.loadingMessage = 'Logging out...';
                    this.waSatus = 'connecting';
                    
                    const unlink = await axios.post(
                        process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/disconnect", 
                        { kodemb: this.kodemb },
                        { headers: { clientid: 'abcd1234' }}
                    );

                    if(unlink.data.status === 200){
                        this.isConected = false;
                        this.qrCodeWa = null;
                        
                        // Stop polling first
                        this.stopPolling();
                        
                        // Restart session to ensure clean state
                        try {
                            await axios.get(
                                process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/restart-instance?kodemb=" + this.kodemb + "&clientid=abcd1234"
                            );
                            console.log("✅ Session restarted after unlink");
                        } catch (restartErr) {
                            console.error("Session restart failed:", restartErr.message);
                        }
                        
                        // Wait for session to restart (1 second)
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        
                        // Show success message
                        Swal.fire("Success", "WhatsApp disconnected. Auto restarting session for valid QR code...", "success");
                        
                        // Reload page after 2 seconds to ensure clean state
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                }
            });
        },
        
        async initialiseAgain(){
            try {
                this.isInitializing = true;
                this.loadingMessage = 'Re-initializing session...';
                this.waSatus = 'connecting';
                this.qrCodeWa = null;
                this.stopPolling();
                
                const kodemb = this.kodemb;
                
                // Use restart-instance instead of force-refresh
                const restart = await axios.get(
                    process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/restart-instance?kodemb=" + kodemb + "&clientid=abcd1234"
                );
                
                if (restart.data.status === 200) {
                    console.log("✅ Session restarted");
                    
                    // Wait for session to start
                    await new Promise(resolve => setTimeout(resolve, 5000));
                    
                    // Restart polling
                    this.startStatusPolling();
                    this.startQRPolling();
                    
                    Swal.fire("Success", "Session restarted! Please wait for QR (10-15 seconds).", "success");
                } else {
                    Swal.fire("Error", restart.data.message || "Failed to restart session", "error");
                }
            } catch (err) {
                console.error("Init error:", err);
                
                // If 404, try to create new session via /init
                if (err.response && err.response.status === 404) {
                    console.log("🔄 Session not found, creating new...");
                    
                    try {
                        const kodemb = this.kodemb;
                        const init = await axios.post(
                            process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/init",
                            {
                                name: kodemb,
                                kodemb: kodemb
                            },
                            { headers: { clientid: "abcd1234" }}
                        );
                        
                        if (init.data.status === 200) {
                            console.log("✅ Session created");
                            await new Promise(resolve => setTimeout(resolve, 5000));
                            this.startStatusPolling();
                            this.startQRPolling();
                            Swal.fire("Success", "Session created! Please wait for QR.", "success");
                        }
                    } catch (initErr) {
                        Swal.fire("Error", "Failed to create session: " + initErr.message, "error");
                    }
                } else {
                    Swal.fire("Error", "Failed to initialize: " + err.message, "error");
                }
            } finally {
                this.isInitializing = false;
            }
        },
        
        async refreshSocket() {
            try {
                this.showRefreshQr = false;
                this.qrCodeWa = null;
                this.waSatus = 'connecting';
                this.loadingMessage = 'Refreshing QR...';
                
                this.stopPolling();
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                this.startStatusPolling();
                this.startQRPolling();

            } catch (err) {
                console.error("Refresh error:", err);
            }
        },
        
        /**
         * Start polling status setiap 3 detik
         */
        startStatusPolling() {
            const kodemb = this.kodemb;
            const self = this;
            
            if (this.statusPolling) return; // Already running
            
            this.statusPolling = setInterval(async () => {
                if (self.statusInFlight) return; // Skip if previous request still in-flight
                    self.statusInFlight = true;
                try {
                    const statusResponse = await axios.get(
                        process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/status?kodemb=" + kodemb + "&clientid=abcd1234",
                        { timeout: 8000 }
                    );
                    
                    if (statusResponse.data.status === 200) {
                        const status = statusResponse.data.data;
                        
                        if (status === 'CONNECTED') {
                            // Debounce: harus 2x CONNECTED berturut-turut
                            // Cegah false-positive saat WAHA restart cycle (WORKING sebentar lalu FAILED)
                            self.connectedConfirmCount = (self.connectedConfirmCount || 0) + 1;
                            console.log(`[STATUS-POLL] CONNECTED confirm: ${self.connectedConfirmCount}/2`);

                            if (self.connectedConfirmCount >= 2) {
                                try {
                                    const infoResponse = await axios.get(
                                        process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/info?kodemb=" + kodemb + "&clientid=abcd1234",
                                        { timeout: 8000 }
                                    );
                                    
                                    if (infoResponse.data.status === 200) {
                                        const accountData = infoResponse.data.data;
                                        self.connectedConfirmCount = 0;
                                        self.isConected = true;
                                        self.waSatus = 'ready';
                                        self.whatsappAccount = accountData;
                                        // Sync whatsappStatus agar watcher bisa detect disconnect selanjutnya
                                        self.whatsappStatus = true;
                                        self.stopPolling();
                                        
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Connected!',
                                            text: 'WhatsApp connected as ' + accountData.pushname,
                                            timer: 3000
                                        });
                                    }
                                } catch (infoErr) {
                                    console.error("Get info error:", infoErr.message);
                                    self.connectedConfirmCount = 0;
                                }
                            }
                        } else if (status === 'FAILED' || status === 'STOPPED' || status === 'NOT CONNECTED') {
                            self.connectedConfirmCount = 0; // Reset counter saat status bukan CONNECTED
                            // Polling tangkap WA disconnect — reset UI jika sebelumnya connected
                            if (self.isConected) {
                                self.isConected = false;
                                self.waSatus = 'connecting';
                                self.loadingMessage = 'WhatsApp disconnected. Waiting for reconnection...';
                                self.qrCodeWa = null;
                                self.whatsappAccount = {};
                                self.whatsappStatus = false;
                            }
                        } else if (status === 'SCAN_QR_CODE') {
                            self._connectedConfirmCount = 0;
                            if (self.isConected) {
                                self.isConected = false;
                                self.whatsappStatus = false;
                            }
                            // Trigger QR polling jika belum berjalan
                            if (!self.qrPolling) {
                                self.startQRPolling();
                            }
                        } else if (status === 'WAITING' || status === 'STARTING') {
                            self._connectedConfirmCount = 0;
                            if (self.isConected) {
                                self.isConected = false;
                                self.waSatus = 'connecting';
                                self.whatsappStatus = false;
                            } else if (self.waSatus !== 'connecting' && self.waSatus !== 'qr_recived') {
                                self.waSatus = 'connecting';
                            }
                        }
                    }
                } catch (err) {
                    // Silent - don't spam console
                } finally {
                    self.statusInFlight = false;
                }
            }, this.pollInterval);
        },
        
        /**
         * Start polling QR code setiap 5 detik
         */
        startQRPolling() {
            const self = this;
            
            if (this.qrPolling) return; // Already running
            
            // Initial fetch after small delay
            setTimeout(() => self.fetchQR(), 1500);
            
            // Then poll at regular interval
            this.qrPolling = setInterval(() => {
                if (!self.isConected && !self.qrCodeWa) {
                    self.fetchQR();
                } else if (self.isConected) {
                    // Stop QR polling when connected
                    clearInterval(self.qrPolling);
                    self.qrPolling = null;
                }
            }, this.qrPollInterval);
            
            // Show refresh button after 30 seconds if no QR
            setTimeout(() => {
                if (!self.qrCodeWa && !self.isConected && !self.showRefreshQr) {
                    self.showRefreshQr = true;
                }
            }, 30000);
        },
        
        /**
         * Fetch QR code dari API
         */
        async fetchQR() {
            if (this.qrInFlight || this.isConected) return; // Guard against overlapping requests

            const kodemb = this.kodemb;
            // Safety guard: don't fetch QR with default session unless explicitly intended
            if (!kodemb || kodemb === 'default') {
                console.warn('[fetchQR] kodemb is default or empty, skipping QR fetch');
                return;
            }

            this.qrInFlight = true;
            
            try {
                const reqQR = await axios.get(
                    process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/qr?clientid=abcd1234&kodemb=" + kodemb,
                    { timeout: 10000 }
                );
                
                if (reqQR.data.status === 200) {
                    const qrData = reqQR.data.data;
                    
                    if (qrData && qrData.qr) {
                        let qrValue = qrData.qr;
                        
                        // WORKAROUND: If backend returns base64, use format=image directly
                        if (qrValue.startsWith('data:image') || !qrValue.startsWith('/')) {
                            qrValue = process.env.VUE_APP_WA_BASE_URL + `api/waha/whatsapp/qr?kodemb=${kodemb}&format=image&clientid=abcd1234`;
                        } else if (qrValue.startsWith('/')) {
                            qrValue = process.env.VUE_APP_WA_BASE_URL + qrValue.substring(1);
                        }
                        
                        this.qrCodeWa = qrValue;
                        this.waSatus = "qr_recived";
                        this.showRefreshQr = false;
                    } else if (qrData && qrData.connected) {
                        this.isConected = true;
                        this.waSatus = 'ready';
                        this.stopPolling();
                    } else if (qrData && qrData.status === 'STARTING') {
                        this.loadingMessage = 'Session starting, QR will appear soon...';
                    }
                }
            } catch (err) {
                // Silent - don't spam console on QR fetch failures
            } finally {
                this.qrInFlight = false;
            }
        },
        
        /**
         * Stop semua polling
         */
        stopPolling() {
            if (this.statusPolling) {
                clearInterval(this.statusPolling);
                this.statusPolling = null;
            }
            if (this.qrPolling) {
                clearInterval(this.qrPolling);
                this.qrPolling = null;
            }
        }
    },
    
    async mounted() {   
        this.initSocket();
        const kodemb = this.kodemb;

        this.waSatus = "connecting";
        this.loadingMessage = "Checking connection...";
        
        // Cek /status dulu — ini source of truth (WAHA tidak cache status)
        // /info bisa return 200 meski session FAILED karena WAHA cache me data
        try {
            const statusRes = await axios.get(
                process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/status?kodemb=" + kodemb + "&clientid=abcd1234",
                { timeout: 8000 }
            );
            
            if (statusRes.data.status === 200 && statusRes.data.data === 'CONNECTED') {
                // Hanya trust /info jika status WAHA memang CONNECTED
                try {
                    const accountWA = await axios.get(
                        process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/info?kodemb=" + kodemb + "&clientid=abcd1234",
                        { timeout: 8000 }
                    );
                    if (accountWA.data.status == 200) {
                        this.whatsappAccount = accountWA.data.data;
                        this.whatsappStatus = true; // Sync mixin agar watcher bisa detect disconnect
                        this.isConected = true;
                        this.waSatus = 'ready';
                        return; // Already connected, no polling needed
                    }
                } catch (_) {
                    // /info gagal, lanjutkan ke polling
                }
            }
        } catch (err) {
            // Not connected or session not found
            if (err.response && err.response.status === 404) {
                this.loadingMessage = "Initializing session...";
                try {
                    await axios.post(
                        process.env.VUE_APP_WA_BASE_URL + "api/waha/whatsapp/init",
                        { name: kodemb, kodemb: kodemb },
                        { headers: { clientid: "abcd1234" }, timeout: 15000 }
                    );
                    // Wait for session to start
                    await new Promise(resolve => setTimeout(resolve, 3000));
                } catch (initErr) {
                    console.error("Auto-init error:", initErr.message);
                }
            }
        }
        
        // Not connected - start polling
        this.loadingMessage = "Waiting for QR code...";
        this.startStatusPolling();
        this.startQRPolling();
    },
    
    async created() {
        // Minimal - mounted() handles the main logic
        this.isConected = false;
        this.waSatus = 'connecting';
    },
    
    beforeUnmount() {
        this.stopPolling();
    },

    watch: {
        // whatsappStatus sudah dihandle penuh oleh SocketMixins.js status handler
        // watcher ini hanya sebagai safety-net untuk sinkronisasi UI tambahan
        whatsappStatus(newVal) {
            if (newVal === true && !this.isConected) {
                // Mixin sudah set isConected dan waSatus, tinggal fetch info akun jika belum ada
                if (!this.whatsappAccount || !this.whatsappAccount.pushname) {
                    const kodemb = this.kodemb;
                    axios.get(
                        process.env.VUE_APP_WA_BASE_URL + 'api/waha/whatsapp/info?kodemb=' + kodemb + '&clientid=abcd1234',
                        { timeout: 8000 }
                    ).then(res => {
                        if (res.data.status === 200) {
                            this.whatsappAccount = res.data.data;
                        }
                    }).catch(() => {});
                }
            }
        }
    }
};
</script>
    
<template>
    <Layout>
        <div class="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div class="file-manager-sidebar" style="height: 100vh;">
                <div class="p-4 d-flex flex-column h-100">
                    <div class="mb-3">
                        <h3 class="text-center">Omni Channel</h3>
                    </div>

                    <div class="px-4 mx-n4" data-simplebar>
                        <ul class="to-do-menu list-unstyled" id="projectlist-data">
                            <li>
                                <a href="#velzonAdmin" class="nav-link fs-13 bg-success text-light active"> Whatsapp</a>
                            </li>
                            <li>
                                <a href-link="" class="nav-link fs-13 bg-info text-light">Telegram <span
                                        class="badge badge-gradient-danger">comming soon</span></a>
                            </li>
                            <li>
                                <a href="#skoteAdmin" class="nav-link fs-13 bg-info text-light">Messenger <span
                                        class="badge badge-gradient-danger">comming soon</span></a>
                            </li>
                            <li>
                                <a href="#ecommerceProject" class="nav-link fs-13 bg-info text-light">Line <span
                                        class="badge badge-gradient-danger">comming soon</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="file-manager-content w-100 p-4 pb-0" style="height: 100vh">
                <div class="hstack mb-4">
                    <button class="btn btn-icon btn-success m-3">
                        <i class="ri-whatsapp-line" style="font-size: 25px;"></i>
                    </button>
                    <h5 class="fw-semibold flex-grow-1 mb-0"> WhatsApp</h5>
                </div>

                <div class="px-4 mx-n4" id="todo-content">
                    <div class="row justify-content-center">
                        <div class="text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <h4 class="mt-4 fw-semibold" v-if="!this.isConected">Scan For Access WhatsApp Channel</h4>
                                    <h4 class="mt-4 fw-semibold" v-else>Ready Connected on WhatsApp</h4>
                                    
                                    <div v-if="!this.isConected" >
                                        <p class="text-muted mt-3">{{ loadingMessage }}</p>
                                        <p class="text-muted mt-2" v-if="waSatus === 'connecting'">
                                            <small>Initializing session... This may take 10-15 seconds.</small>
                                        </p>
                                        <p class="text-muted mt-3">
                                            <a href="javascript:void(0)" @click="initialiseAgain" :disabled="isInitializing">
                                                {{ isInitializing ? 'Initializing...' : 'Click here for re-initialise' }}
                                            </a>
                                        </p>
                                    </div>
                                    <div v-else>
                                        <p v-if="Object.keys(this.whatsappAccount).length >= 1">
                                            Account Number : {{ this.whatsappAccount.wid?.user ?? 'N/A' }}<br>
                                            Account Name : {{ this.whatsappAccount.pushname ?? 'N/A' }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">
                                <div v-if="waSatus === 'qr_recived' && qrCodeWa" class="col-sm-7 col-8">
                                    <div class="qr-container" style="max-width: 300px; margin: 0 auto;">
                                        <img 
                                            :src="qrCodeWa" 
                                            alt="QR Code" 
                                            class="img-fluid qr-image" 
                                            style="width: 100%; height: auto; display: block;"
                                        />
                                    </div>
                                    <p class="text-muted mt-3"><small>Scan this QR code with your WhatsApp</small></p>
                                </div>
                                <div v-else-if="waSatus === 'connecting' || waSatus === 'disconnect'" class="col-sm-7 col-8">
                                    <lottie
                                        colors="primary:#0ab39c,secondary:#405189"
                                        :options="defaultOptions"
                                        :height="200"
                                        :width="200"
                                    />
                                    <p class="text-muted mt-2"><small>{{ loadingMessage }}</small></p>
                                </div>
                                <div v-else-if="waSatus === 'ready'" class="col-sm-7 col-8" style="height: 250px;">
                                    <lottie
                                        colors="primary:#0ab39c,secondary:#405189"
                                        :options="optReadyData"
                                        :height="300"
                                        :width="300"
                                    />
                                </div>
                                
                                <div v-if="waSatus === 'ready'" class="col-sm-7 col-12 mt-3">
                                    <button class="btn btn-danger" @click="unlinkWa">Unlink WhatsApp</button>
                                </div>
                                
                                <div v-if="showRefreshQr && !qrCodeWa && !isConected" class="col-sm-7 col-12 mt-3">
                                    <button class="btn btn-info" @click="refreshSocket">Refresh QR</button>
                                    <p class="text-muted mt-2"><small>QR code not appearing? Click to refresh.</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>